// Library import
import { useEffect, useState, useRef } from 'react';
import { Form, Alert } from 'react-bootstrap';
import Proptypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// File Import
import uploadIcon from '~/images/icon/upload.png';
import CrossIcon from '~/images/icon/cross-gray.png';
import PlusIcon from '~/images/icon/square-plus.png';
import MiniCross from '~/images/icon/mini-cross.png';
import LoadingGif from '~/images/common/loading.gif';
import { jobHunting, skillSupport, postType } from '@/constant';
import { TagApi, PostApi } from '@/http';
import { getTagsBasedOnGroup } from '@/config/mixins';
import { formatDate } from '@/config';

// Components Import
import { ScheduleModal, AddSinglePost, PostPreviewModal, SingleCalendar } from '@/components';

const initialFormData = {
  title: '',
  image: '',
  url: '',
  tags: [],
  notification_flg: 1,
  map_flg: 1,
  ci_seminar_flg: 1,
  ci_address: '',
  ci_description: '',
  ci_end_date: '',
  ci_start_date: '',
  ci_title: '',
  ci_url: '',
  ci_start_time: '',
  ci_end_time: '',
  ci_start_minute: '',
  ci_end_minute: '',
  ci_seminar_items: [
    {
      ci_address: '',
      ci_description: '',
      ci_end_date: '',
      ci_start_date: '',
      ci_title: '',
      ci_url: '',
      ci_start_time: '',
      ci_end_time: '',
      ci_start_minute: '',
      ci_end_minute: ''
    }
  ],
  user_name: ''
};

const initialSection = [
  {
    title: '',
    description: ''
  }
];

export const SinglePostForm = ({ postData, locationsCsv }) => {
  // const [loading, setLoading] = useState(false);
  const url = new URL(window.location.href);
  const [typeParam, setTypeParam] = useState(null);
  const [tags, setTags] = useState([]);
  const [loadMore, setLoadMore] = useState(false);
  const [formData, setFormData] = useState(initialFormData || {});
  const [itemTitles, setItemTitles] = useState([]);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [postPreviewModal, setPostPreviewModal] = useState(false);
  const [items, setItems] = useState([]);
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState('');
  const [postStatus, setPostStatus] = useState('');
  const [errorStatus, setErrorStatus] = useState(false);
  const [originalImage, setOriginalImage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [publishedDate, setPublishedDate] = useState(new Date());
  const [isDisabled, setIsDisabled] = useState(true);
  const [ready, setReady] = useState(false);
  const [seminarItems, setSeminarItems] = useState(initialFormData.ci_seminar_items);
  // const [userName, setUserName] = useState('');
  const mapTitle = jobHunting[7];
  const emptyMapItem = [{ preset_name: 'empty', address: '', place_id: '', place_name: '', latitude: '', longitude: '' }];
  const emptyCalendarData = [
    {
      ci_address: '',
      ci_description: '',
      ci_end_date: '',
      ci_start_date: '',
      ci_title: '',
      ci_url: '',
      ci_start_time: '',
      ci_end_time: '',
      ci_start_minute: '',
      ci_end_minute: ''
    }
  ];
  const fileUploadRef = useRef(null);

  useEffect(() => {
    setTypeParam(`${url.searchParams.get('type')}`);
    if (postData) {
      const calendar_info_res = postData?.calendar_info ? JSON.parse(postData?.calendar_info) : null;
      const ci_seminar_items = [];
      var map_flg = 1;

      if (url.searchParams.get('type') === 'news') {
        map_flg = 0;
        for (let i = 0; i < postData.items.length; i++) {
          if (postData.items[i].title === mapTitle) {
            map_flg = 1;
            break;
          }
        }

        if (map_flg === 0) {
          const emptyMapField = { title: mapTitle, map_items: [emptyMapItem[0]] };
          const newItem = [];
          newItem.push(emptyMapField);
          newItem.push(...postData.items);
          postData.items = newItem;
        }
      }

      if (calendar_info_res?.seminar_items && calendar_info_res?.seminar_items.length > 0) {
        calendar_info_res?.seminar_items.forEach((element) => {
          ci_seminar_items.push({
            ci_address: element?.address,
            ci_description: element?.description,
            ci_end_date: element?.end_date,
            ci_start_date: element?.start_date,
            ci_title: element?.title,
            ci_url: element?.url,
            ci_start_time: element?.start_date?.substr(11, 2),
            ci_end_time: element?.end_date?.substr(11, 2),
            ci_start_minute: element?.start_date?.substr(14),
            ci_end_minute: element?.end_date?.substr(14)
          });
        });
      } else {
        if (
          calendar_info_res?.address ||
          calendar_info_res?.description ||
          calendar_info_res?.start_date ||
          calendar_info_res?.end_date ||
          calendar_info_res?.title ||
          calendar_info_res?.url
        ) {
          ci_seminar_items.push({
            ci_address: calendar_info_res?.address,
            ci_description: calendar_info_res?.description,
            ci_end_date: calendar_info_res?.end_date,
            ci_start_date: calendar_info_res?.start_date,
            ci_title: calendar_info_res?.title,
            ci_url: calendar_info_res?.url,
            ci_start_time: calendar_info_res?.start_date?.substr(11, 2),
            ci_end_time: calendar_info_res?.end_date?.substr(11, 2),
            ci_start_minute: calendar_info_res?.start_date?.substr(14),
            ci_end_minute: calendar_info_res?.end_date?.substr(14)
          });
        } else {
          ci_seminar_items.push(emptyCalendarData[0]);
        }
      }
      setFormData({
        ...formData,
        title: postData?.title ? postData?.title : '',
        id: postData?.id,
        image: postData?.original_image ? postData?.original_image : '',
        status: postData?.status,
        scheduled_at: postData?.scheduled_at,
        url: postData?.url ? postData?.url : '',
        tags: getTagsBasedOnGroup(postData?.tags),
        notification_flg: postData?.notification_flg,
        expired_at: postData?.expired_at,
        map_flg: map_flg,
        ci_address: calendar_info_res?.address,
        ci_description: calendar_info_res?.description,
        ci_end_date: calendar_info_res?.end_date,
        ci_start_date: calendar_info_res?.start_date,
        ci_title: calendar_info_res?.title,
        ci_url: calendar_info_res?.url,
        ci_start_time: calendar_info_res?.start_date?.substr(11, 2),
        ci_end_time: calendar_info_res?.end_date?.substr(11, 2),
        ci_start_minute: calendar_info_res?.start_date?.substr(14),
        ci_end_minute: calendar_info_res?.end_date?.substr(14),
        ci_seminar_flg: calendar_info_res ? 1 : 0,
        ci_seminar_items: ci_seminar_items,
        user_name: postData?.user_name ? postData?.user_name : ''
      });
      setItems([...postData.items]);
      setSeminarItems(ci_seminar_items);
      setOriginalImage(postData?.image);
      setIsDisabled(false);
    } else {
      const emptyField = { title: '', description: '' };
      if (url.searchParams.get('type') === 'news') {
        const emptyMapField = { title: mapTitle, map_items: [emptyMapItem[0]] };
        setItems((prevProps) => [...prevProps, emptyMapField]);
      }
      setItems((prevProps) => [...prevProps, emptyField]);
    }

    if (postData?.published_at) {
      setPublishedDate(new Date(postData?.published_at));
    }

    setReady(true);
    // setUserName(handleGetUsername());
  }, []);

  useEffect(() => {
    if (formData.ci_seminar_flg === 0) {
      setFormData({
        ...formData,
        ci_address: '',
        ci_description: '',
        ci_end_date: '',
        ci_start_date: '',
        ci_title: '',
        ci_url: '',
        ci_start_time: '',
        ci_end_time: '',
        ci_start_minute: '',
        ci_end_minute: ''
      });
    }
  }, [formData.ci_seminar_flg]);

  useEffect(() => {
    if (typeParam) fetchTags();
    if (typeParam) setItemTitles(getItemBasedOnType());
  }, [typeParam]);

  useEffect(() => {
    if (!ready) return;
    handleCheckRequired();
  }, [formData, items, tags, originalImage, ready]);

  const fetchTags = async () => {
    try {
      const response = await TagApi.getTags(typeParam);

      const data = getTagsBasedOnGroup(response.data.data);

      if (postData?.tags?.length) {
        data?.map((value, index) =>
          postData?.tags?.some((oneElement) => {
            if (oneElement.id === value.id) {
              setTags([...tags, (data[index] = { ...value, selected: true })]);
            }
            setTags(data);
          })
        );
      } else {
        setTags(data);
      }
    } catch (error) {
      setServerError('Server error occured !');
    }
  };

  /**
   * Open upload file
   * @param {*} event
   * @returns
   */
  const handleFileChange = (event) => {
    event.preventDefault();
    const { files } = event.currentTarget;
    if (!files || !files[0]) return;
    handleUploadImage(files);
  };

  /**
   * Drop upload file
   * @param {*} event
   */
  const handleFileDrop = (event) => {
    event.preventDefault();
    if (!event.dataTransfer || !event.dataTransfer.files || !event.dataTransfer.files[0]) return;
    handleUploadImage(event.dataTransfer.files);
  };

  // Upload Image API handle
  const handleUploadImage = async (fileData) => {
    const formData = new FormData();

    if (fileData) formData.append('image', fileData[0]);
    try {
      setErrors({ ...errors, image: '' });
      setIsUploading(true);
      const response = await PostApi.uploadImage(formData);
      if (response.status === 200) {
        setErrors({ ...errors, image: '' });
        setTimeout(() => {
          setIsUploading(false);
        }, 1000);
        setOriginalImage(response.data.data.original_url);
        handleChange({
          target: {
            name: 'image',
            value: response.data.data.image_url
          }
        });
      }
    } catch (error) {
      setIsUploading(false);
      if (error.response.status === 422) {
        setErrors({ ...errors, image: error.response.data.message });
      } else {
        setErrors({ ...errors, image: 'Server error occured !' });
      }
    }
  };

  // Handle Section Tags
  const getItemBasedOnType = () => {
    switch (typeParam) {
      case 'job_hunting':
        return jobHunting;

      case 'skill_support':
        return skillSupport;
    }
  };

  // Handle Add New Post
  const handleAddPost = () => {
    const emptyItem = {
      title: '',
      description: ''
    };
    setItems((prevProps) => [...prevProps, emptyItem]);
  };

  /* Handle remove post */
  /**
   * Post remove if clicked on post  cross icon
   * Section remove if clicked on  section cross icon
   * Remove action fired based on index number availibity
   */
  const handleRemovePost = (postIndex = null) => {
    const copyItems = [...items];

    if (copyItems?.length > 1) {
      const updateItems = copyItems?.filter((item, index) => index !== postIndex ?? item);

      setItems(updateItems);
    }
  };

  // Handle select tag
  const handleSelectTag = (tag) => {
    const filterArr = tags?.map((item) => {
      if (item.id === tag.id) return { ...item, selected: true };
      return item;
    });

    setFormData({ ...formData, tags: [...formData.tags, tag] });
    setTags(filterArr);
    if (formData?.tags?.length) {
      setErrors({ ...errors, tags: 'タグを設定してください' });
    } else {
      setErrors({ ...errors, tags: '' });
    }
  };

  // Handle remove tag
  const handleRemoveTag = (tag) => {
    const filterArr = formData?.tags?.filter((item) => item.id !== tag.id);

    const updateArr = tags?.map((item) => {
      if (item.id === tag.id) return { ...item, selected: false };
      return item;
    });

    setTags(updateArr);
    setFormData({ ...formData, tags: filterArr });

    if (formData?.tags?.length) {
      setErrors({ ...errors, tags: 'タグを設定してください' });
    } else {
      setErrors({ ...errors, tags: '' });
    }
  };

  /* Handle change event */
  /**
   * Handle normal formadata on change event, which update formdata
   * Hadle section on change event, which update section inputs
   * Handle post on change event, which update post inputs
   */
  const handleChange = (event, postIndex = null, mapIndex = null, calendarIndex = null) => {
    const copyItems = [...items];
    // Formdata handle change
    if (postIndex === null && mapIndex === null) {
      if (calendarIndex === null) {
        setFormData({ ...formData, [event.target.name]: event.target.value });
      } else {
        seminarItems[calendarIndex][event.target.name] = event.target.value;
        if (calendarIndex === 0) {
          setFormData({ ...formData, [event.target.name]: event.target.value });
        } else {
          setFormData({ ...formData });
        }
      }

      if (errorStatus) {
        setErrors({ ...errors, [event.target.name]: '' });
      }
    }

    if (postIndex !== null && mapIndex !== null) {
      if (errorStatus) {
        let updateError = { ...errors };

        if (updateError.items?.[postIndex]?.map_items?.[mapIndex]?.[event.target.name] !== undefined) {
          updateError.items[postIndex].map_items[mapIndex][event.target.name] = '';
        }

        setErrors(updateError);
      }
      //  Data CSV
      if (event.target.name === 'preset_name') {
        // Clear content if preset_name = empty
        if (event.target.value === 'empty') {
          copyItems[postIndex].map_items[mapIndex] = {
            preset_name: 'empty',
            address: '',
            place_id: '',
            place_name: '',
            latitude: '',
            longitude: ''
          };
        } else {
          // find preset_name
          const objCsv = locationsCsv.find((c) => c.preset_name === event.target.value);
          // exists
          if (objCsv) {
            Object.keys(objCsv).forEach((key) => (copyItems[postIndex].map_items[mapIndex][key] = objCsv[key]));
          }
        }
      } else {
        copyItems[postIndex].map_items[mapIndex][event.target.name] = event.target.value;
      }
      setItems(copyItems);
    } else if (postIndex !== null && mapIndex === null) {
      // Init change controll コンテンツタイトル type 地図で見る
      if (copyItems[postIndex] && !copyItems[postIndex].map_items && event.target.value === mapTitle) {
        // Clear description after change コンテンツタイトル
        copyItems[postIndex].description = '';
        // Empty
        copyItems[postIndex].map_items = emptyMapItem;
      } else {
        // remove properti map_items
        delete copyItems[postIndex].map_items;
      }
      if (errorStatus) {
        let updateError = { ...errors };

        if (updateError.items?.[postIndex]?.[event.target.name] !== undefined) updateError.items[postIndex][event.target.name] = '';

        setErrors(updateError);
      }

      copyItems[postIndex][event.target.name] = event.target.value;
      setItems(copyItems);
    }
    // if (event.target.name === 'title') handleSectionOption(event.target.value);
  };

  // Handle Section Option
  const handleSectionOption = (option) => {
    const copyTitles = [...itemTitles];

    const updateArr = copyTitles?.filter((item) => item !== option);
    setItemTitles(updateArr);
  };

  // Form validation final codes
  const findFormErrors = (checkType) => {
    const { title, title_free, image, url, tags, ci_title, ci_seminar_flg, user_name, ci_seminar_items } = formData;
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    const mapRegex = /^((\-?|\+?)?\d+(\.\d+)?)$/;

    const newErrors = { items: [] };

    let hasError = false;

    if ((!title || title === '') && (checkType === 'all' || checkType === 'required')) {
      newErrors.title = '記事タイトルを入力してください';
      hasError = true;
    } else if (title && title.length < 2 && (checkType === 'all' || checkType === 'value')) {
      newErrors.title = 'タイトルは 2 文字以上にする必要があります';
      hasError = true;
    } else if (title && title.length > 256 && (checkType === 'all' || checkType === 'value')) {
      newErrors.title = 'タイトルは 256 文字以下にする必要があります';
      hasError = true;
    }
    if ((!image || image === '') && (checkType === 'all' || checkType === 'required')) {
      newErrors.image = 'トップイメージをアップロードしてください';
      hasError = true;
    }
    if (url && !urlRegex.test(url) && (checkType === 'all' || checkType === 'value')) {
      newErrors.url = 'URL は有効な URL でなければなりません';
      hasError = true;
    }
    if ((!tags || !tags?.length) && (checkType === 'all' || checkType === 'required')) {
      newErrors.tags = 'タグを設定してください';
      hasError = true;
    }
    if ((!user_name || user_name === '') && (checkType === 'all' || checkType === 'required')) {
      newErrors.user_name = '担当者名を入力してください';
      hasError = true;
    }

    if (ci_seminar_flg == 1) {
      // セミナーとして登録する TRUE
      if (ci_seminar_items) {
        ci_seminar_items.forEach((element, index) => {
          // セミナー名
          if ((!element.ci_title || element.ci_title === '') && (checkType === 'all' || checkType === 'required')) {
            newErrors[`ci_title${index}`] = 'セミナー名を入力してください';
            hasError = ci_title;
          }

          // セミナー内容
          if ((!element.ci_address || element.ci_address === '') && (checkType === 'all' || checkType === 'required')) {
            newErrors[`ci_address${index}`] = '開催場所を入力してください';
            hasError = true;
          }

          // 開催場所
          if ((!element.ci_description || element.ci_description === '') && (checkType === 'all' || checkType === 'required')) {
            newErrors[`ci_description${index}`] = 'セミナー内容を入力してください';
            hasError = true;
          }

          // URL
          if (element.ci_url && !urlRegex.test(element.ci_url) && (checkType === 'all' || checkType === 'value')) {
            newErrors[`ci_url${index}`] = 'URL は有効な URL でなければなりません';
            hasError = true;
          }

          // 日付日時
          if (
            (!element.ci_start_date || element.ci_start_date === '' || element.ci_start_date === null) &&
            (checkType === 'all' || checkType === 'required')
          ) {
            newErrors[`ci_start_date${index}`] = '日付を選択してください';
            hasError = true;
          }

          // 日付日時
          if (
            (!element.ci_end_date || element.ci_end_date === '' || element.ci_end_date === null) &&
            (checkType === 'all' || checkType === 'required')
          ) {
            newErrors[`ci_end_date${index}`] = '日付を選択してください';
            hasError = true;
          } else if (new Date(element.ci_end_date) < new Date(element.ci_start_date)) {
            //終了日時 < 開始日時
            newErrors[`ci_date_time_laterthan${index}`] = '開催日時よりも後の日時を設定してください';
            hasError = true;
          } else if (
            element.ci_start_date &&
            element.ci_end_date &&
            element.ci_end_time &&
            element.ci_start_time &&
            element.ci_start_minute &&
            element.ci_end_minute
          ) {
            const start = new Date(
              `${formatDate(element.ci_start_date, 'YYYY-MM-DD')} ${element.ci_start_time}:${element.ci_start_minute}`
            );
            const end = new Date(`${formatDate(element.ci_end_date, 'YYYY-MM-DD')} ${element.ci_end_time}:${element.ci_end_minute}`);
            if (
              start.getFullYear() === end.getFullYear() &&
              start.getMonth() === end.getMonth() &&
              start.getDate() === end.getDate() &&
              (end.getHours() < start.getHours() || (end.getHours() === start.getHours() && end.getMinutes() <= start.getMinutes()))
            ) {
              newErrors[`ci_date_time_laterthan${index}`] = '開催日時よりも後の日時を設定してください';
              hasError = true;
            }
          }

          // 時間
          if ((!element.ci_start_time || element.ci_start_time === '') && (checkType === 'all' || checkType === 'required')) {
            newErrors[`ci_start_time${index}`] = '時間を選択してください';
            hasError = true;
          }
          if ((!element.ci_start_minute || element.ci_start_minute === '') && (checkType === 'all' || checkType === 'required')) {
            newErrors[`ci_start_minute${index}`] = '分を選択してください';
            hasError = true;
          }
          // 時間
          if ((!element.ci_end_time || element.ci_end_time === '') && (checkType === 'all' || checkType === 'required')) {
            newErrors[`ci_end_time${index}`] = '時間を選択してください';
            hasError = true;
          }
          if ((!element.ci_end_minute || element.ci_end_minute === '') && (checkType === 'all' || checkType === 'required')) {
            newErrors[`ci_end_minute${index}`] = '分を選択してください';
            hasError = true;
          }
        });
      }
    }

    const getErrorMsg = (key, input, title = null, other = null) => {
      if (input === 'title') {
        if ((!key || key === '') && (checkType === 'all' || checkType === 'required')) {
          hasError = true;
          return 'コンテンツタイトルを選択してください';
        } else if (key && key.length < 2 && (checkType === 'all' || checkType === 'value')) {
          hasError = true;
          return 'タイトルは 2 文字以上にする必要があります';
        } else if (key && key.length > 1000 && (checkType === 'all' || checkType === 'value')) {
          hasError = true;
          return 'タイトルは 1000 文字以下にする必要があります';
        }
      }

      if (input === 'title_free') {
        if ((!key || key === '') && (checkType === 'all' || checkType === 'required')) {
          hasError = true;
          return 'コンテンツタイトルを入力してください';
        } else if (key && key.length < 2 && (checkType === 'all' || checkType === 'value')) {
          hasError = true;
          return 'タイトルは 2 文字以上にする必要があります';
        } else if (key && key.length > 1000 && (checkType === 'all' || checkType === 'value')) {
          hasError = true;
          return 'タイトルは 1000 文字以下にする必要があります';
        }
      }

      if (input === 'description' && title !== mapTitle) {
        if ((!key || key === '') && (checkType === 'all' || checkType === 'required')) {
          hasError = true;
          return 'コンテンツ本文を入力してください';
        } else if (key && key.length < 2 && (checkType === 'all' || checkType === 'value')) {
          hasError = true;
          return '説明は 2 文字以上にする必要があります';
        } else if (key && key.length > 1000 && (checkType === 'all' || checkType === 'value')) {
          hasError = true;
          return '説明は 1000 文字以下にする必要があります';
        }
      }

      if (title === mapTitle && formData.map_flg === 1) {
        if (input === 'place_id') {
          if ((!key || key === '') && (!other || other === '') && (checkType === 'all' || checkType === 'required')) {
            hasError = true;
            return 'プレイス（場所）IDを入力してください';
          }
        }

        if (input === 'place_name') {
          if ((!key || key === '') && (checkType === 'all' || checkType === 'required')) {
            hasError = true;
            return '場所名称を入力してください';
          }
        }

        if (input === 'latitude') {
          if (key === '' && (!other || other === '') && (checkType === 'all' || checkType === 'required')) {
            hasError = true;
            return '緯度を入力してください';
          } else if (key && !mapRegex.test(key)) {
            hasError = true;
            return '緯度は数値のみで入力してくだい';
          }
        }

        if (input === 'longitude') {
          if (key === '' && (!other || other === '') && (checkType === 'all' || checkType === 'required')) {
            hasError = true;
            return '経度を入力してください';
          } else if (key && !mapRegex.test(key)) {
            hasError = true;
            return '経度は数値のみで入力してくだい';
          }
        }
      }
      return '';
    };

    items?.forEach((section, index) => {
      newErrors.items[index] = {
        title: getErrorMsg(items[index].title, 'title'),
        title_free: items[index].title === '自由入力' ? getErrorMsg(items[index].title_free, 'title_free') : '',
        description: getErrorMsg(items[index].description, 'description', items[index].title),
        map_items: items[index].map_items?.map((content, idx) => {
          return {
            address: getErrorMsg(items[index].map_items[idx].address, 'address', items[index].title),
            place_id: getErrorMsg(
              items[index].map_items[idx].place_id,
              'place_id',
              items[index].title,
              items[index].map_items[idx].latitude + items[index].map_items[idx].longitude
            ),
            place_name: getErrorMsg(items[index].map_items[idx].place_name, 'place_name', items[index].title),
            latitude: getErrorMsg(
              items[index].map_items[idx].latitude,
              'latitude',
              items[index].title,
              items[index].map_items[idx].place_id
            ),
            longitude: getErrorMsg(
              items[index].map_items[idx].longitude,
              'longitude',
              items[index].title,
              items[index].map_items[idx].place_id
            )
          };
        })
      };
    });

    setErrorStatus(hasError);

    return { newErrors, hasError };
  };

  // Handle Post Submit
  const handlePostPublish = (event, actionType) => {
    const { newErrors, hasError } = findFormErrors('all');

    if (hasError) {
      // We got errors!
      setErrors(newErrors);
      if (actionType === 'preview') {
        setPostPreviewModal(true);
        setErrorStatus(false);
      }
    } else {
      const published_at = `${formatDate(publishedDate, 'YYYY-MM-DD')}`;
      // Calendar info
      let objCI = '';
      // セミナーとして登録する check
      if (formData.ci_seminar_flg == 1) {
        const startDate = `${formatDate(formData.ci_start_date, 'YYYY-MM-DD')} ${formData.ci_start_time}:${formData.ci_start_minute}`;
        const endDate = `${formatDate(formData.ci_end_date, 'YYYY-MM-DD')} ${formData.ci_end_time}:${formData.ci_end_minute}`;
        objCI = {
          address: formData.ci_address && formData.ci_address !== '' ? formData.ci_address : '',
          description: formData.ci_description && formData.ci_description !== '' ? formData.ci_description : '',
          end_date: endDate,
          start_date: startDate,
          title: formData.ci_title && formData.ci_title !== '' ? formData.ci_title : '',
          url: formData.ci_url && formData.ci_url !== '' ? formData.ci_url : ''
        };
        objCI = JSON.stringify(objCI);
      }
      setFormData({ ...formData, items, type: typeParam, published_at: published_at, calendar_info: objCI });
      if (actionType === 'submit') {
        setShowScheduleModal(true);
      } else if (actionType === 'preview') {
        setPostPreviewModal(true);
      }
    }
  };

  // Handle remove image
  const handleRemoveImage = (event) => {
    event.stopPropagation();
    setOriginalImage(null);
    handleChange({
      target: {
        name: 'image',
        value: ''
      }
    });
  };

  const handleCheckboxChange = (event) => {
    handleChange({
      target: {
        name: event.target.name,
        value: event.target.checked ? 1 : 0
      }
    });
  };

  // Handle draft Post Submit
  const handleDraftPostSubmit = (event) => {
    setErrors({});
    const { newErrors, hasError } = findFormErrors('value');

    if (hasError) {
      // We got errors!
      setErrors(newErrors);
    } else {
      const published_at = `${formatDate(publishedDate, 'YYYY-MM-DD')}`;
      // Calendar info
      let objCI = '';
      // セミナーとして登録する check
      if (formData.ci_seminar_flg == 1) {
        const startDate = `${formatDate(formData.ci_start_date, 'YYYY-MM-DD')} ${formData.ci_start_time}:${formData.ci_start_minute}`;
        const endDate = `${formatDate(formData.ci_end_date, 'YYYY-MM-DD')} ${formData.ci_end_time}:${formData.ci_end_minute}`;
        objCI = {
          address: formData.ci_address && formData.ci_address !== '' ? formData.ci_address : '',
          description: formData.ci_description && formData.ci_description !== '' ? formData.ci_description : '',
          end_date: formData.ci_end_date && formData.ci_end_time && formData.ci_end_minute ? endDate : '',
          start_date: formData.ci_start_date && formData.ci_start_time && formData.ci_start_minute ? startDate : '',
          title: formData.ci_title && formData.ci_title !== '' ? formData.ci_title : '',
          url: formData.ci_url && formData.ci_url !== '' ? formData.ci_url : ''
        };
        objCI = JSON.stringify(objCI);
      }
      setFormData({ ...formData, items, type: typeParam, published_at: published_at, calendar_info: objCI }); //, user_name: userName
      setShowScheduleModal(true);
    }
  };

  const handleCheckRequired = () => {
    setErrors({});
    const { newErrors, hasError } = findFormErrors('required');

    if (hasError) {
      setIsDisabled(true);
      setErrors(newErrors);
    } else {
      setIsDisabled(false);
    }
  };

  // Handle add new map section
  const handleAddMapSection = (postIndex) => {
    const copyItems = [...items];
    copyItems[postIndex].map_items.push(emptyMapItem[0]);
    setItems(copyItems);
  };

  // Handle remove map section
  const handleRemoveMapSection = (postIndex, mapIndex) => {
    const copyItems = [...items];
    const map_items = copyItems[postIndex].map_items;

    if (map_items?.length > 1) {
      const updateItems = map_items?.filter((item, index) => index !== mapIndex ?? item);

      copyItems[postIndex].map_items = updateItems;
      setItems(copyItems);
    }
  };

  // Handle add new calendar section
  const handleAddCalendarSection = () => {
    const copyFormData = formData;
    copyFormData.ci_seminar_items.push(emptyCalendarData[0]);
    setSeminarItems(copyFormData.ci_seminar_items);
    setFormData({ ...formData, ['ci_seminar_items']: copyFormData.ci_seminar_items });
  };

  // Handle remove calendar section
  const handleRemoveCalendarSection = (calendarIndex) => {
    const copyFormData = formData;
    const calendar_data = copyFormData.ci_seminar_items;

    if (calendar_data?.length > 1) {
      const updateCalendars = calendar_data?.filter((element, index) => index !== calendarIndex ?? element);
      copyFormData.ci_seminar_items = updateCalendars;
      setSeminarItems(copyFormData.ci_seminar_items);
      setFormData({ ...formData, ['ci_seminar_items']: copyFormData.ci_seminar_items });
    }
  };

  /**
   * Change Date and time
   *
   * @param {*} name name control
   * @param {*} val value control
   */
  const handleChangeDateTime = (name, val, index) => {
    if (index !== null) {
      seminarItems[index][name] = val;
      if (index === 0) {
        setFormData({ ...formData, [name]: val });
      } else {
        setFormData({ ...formData });
      }
    }
  };

  const handleGetUsername = () => {
    let element = document.getElementById('Header');
    let userName = '';
    if (element) {
      const currentUser = element?.dataset?.user && JSON.parse(element.dataset.user);
      userName = currentUser.name;
    }
    return userName;
  };

  /**
   * Swap
   *
   * @param list Array
   * @param idxStart Index start
   * @param idxEnd Index end
   */
  const swapPost = (list, idxStart, idxEnd) => {
    const temp = list[idxStart];
    list[idxStart] = list[idxEnd];
    list[idxEnd] = temp;
  };

  /**
   * Handle swap post
   *
   * @param idxStart index current
   * @param idxEnd indexEnd - 1 || indexEnd + 1
   * @returns
   */
  const handleSwapPost = (idxStart, idxEnd) => {
    if (!items && !(idxStart < 0 && idxEnd > items.length - 1)) return;
    let tempItems = items;
    swapPost(tempItems, idxStart, idxEnd);
    setItems([...tempItems]);
  };

  return (
    <div className='page-wrapper bg-gray px-4'>
      <Form className='form-area' onSubmit={(event) => event.preventDefault()}>
        {/* Header title */}
        <Form.Group className='mb-3' controlId='title'>
          <Form.Label>
            タイトル<span className='is-required'>*</span>
          </Form.Label>
          <Form.Control
            name='title'
            value={formData?.title}
            onChange={(event) => handleChange(event)}
            type='text'
            placeholder={
              typeParam !== 'news'
                ? '19文字以内の記入を推奨します（超過部分が...の表示になる場合があります）'
                : '28文字以内の記入を推奨します（超過部分が...の表示になる場合があります）'
            }
            isInvalid={errors?.title}
          />

          <Form.Control.Feedback type='invalid'>{errors?.title}</Form.Control.Feedback>
        </Form.Group>

        {/* Header Image */}
        <Form.Group className='mb-4' controlId='uploadMainImage'>
          <Form.Label>
            トップイメージアップロード<span className='is-required'>*</span>
            <span className='is-allowed'>PNG,JPG & GIF files are allowed</span>
          </Form.Label>

          <div
            className={errors?.image ? 'form-file is-invalid' : 'form-file'}
            onDragOver={handleFileDrop}
            onDrop={handleFileDrop}
            onClick={() => fileUploadRef?.current?.click()}>
            <input
              id='uploadMainImage'
              type='file'
              hidden
              onChange={(event) => handleFileChange(event)}
              ref={fileUploadRef}
              accept='image/png, image/gif, image/jpeg'
            />
            <div className='file-content'>
              {originalImage !== null ? (
                <div className='preview-content'>
                  <img src={originalImage} alt='Header Image' />
                </div>
              ) : (
                <>
                  <img src={uploadIcon} alt='Upload Icon' />
                  <span>クリックして画像を追加</span>
                </>
              )}
            </div>
            {isUploading && (
              <div className='upload-image'>
                <img src={LoadingGif} style={{ width: '170px' }} alt='Loading Image' />
              </div>
            )}

            {/* Remove upload image */}
            {originalImage !== null && !isUploading && (
              <div className='remove-item remove-image'>
                <img onClick={handleRemoveImage} src={CrossIcon} alt='Cross Icon' />
              </div>
            )}
          </div>

          <Form.Control.Feedback type='invalid'>{errors?.image}</Form.Control.Feedback>
        </Form.Group>

        {/* 記事投稿日（表示用） */}
        <Form.Group className='mb-3 w-100' controlId='published_date'>
          <div className='position-relative'>
            <Form.Label>
              記事投稿日（表示用）<span className='is-required'>*</span>
            </Form.Label>
            <DatePicker
              selected={publishedDate}
              id='published_date'
              placeholderText='Select Date'
              onChange={(date) => {
                if (date) setPublishedDate(date);
                if (!date) setPublishedDate(new Date());
              }}
              maxDate={new Date('9999-12-31')}
              dateFormat='yyyy-MM-dd'
              className='form-control'
            />
          </div>
        </Form.Group>

        {/* Multi section */}
        {items?.map((item, index) =>
          (typeParam === 'news' && item.title !== mapTitle) || typeParam !== 'news' ? (
            <AddSinglePost
              key={index}
              postIndex={index}
              handleChange={handleChange}
              handleRemovePost={handleRemovePost}
              handleAddMapSection={handleAddMapSection}
              handleRemoveMapSection={handleRemoveMapSection}
              item={item}
              itemTitles={itemTitles}
              errors={errors.items && errors.items[index]}
              mapTitle={mapTitle}
              locationsCsv={locationsCsv}
              handleSwapPost={handleSwapPost}
              itemsLength={items?.length}
            />
          ) : (
            ''
          )
        )}

        {/* Add new section */}
        {items?.length < getItemBasedOnType()?.length && (
          <div className='add-new' onClick={() => handleAddPost()}>
            <img src={PlusIcon} alt='Plus Icon' />
          </div>
        )}
        {typeParam === 'news' && (
          <div className='add-new' onClick={() => handleAddPost()}>
            <img src={PlusIcon} alt='Plus Icon' />
          </div>
        )}

        {/* Map Section for News type*/}
        {typeParam === 'news' &&
          items.map((item, index) =>
            item.title === mapTitle ? (
              <AddSinglePost
                key={index}
                postIndex={index}
                handleChange={handleChange}
                handleRemovePost={handleRemovePost}
                handleAddMapSection={handleAddMapSection}
                handleRemoveMapSection={handleRemoveMapSection}
                item={item}
                itemTitles={itemTitles}
                errors={errors.items && errors.items[index]}
                mapTitle={mapTitle}
                locationsCsv={locationsCsv}
                handleSwapPost={handleSwapPost}
                itemsLength={items?.length}
                postType={typeParam}
                disable={formData.map_flg}
                handleCheckboxChange={handleCheckboxChange}
              />
            ) : (
              ''
            )
          )}

        {/* Url Input */}
        <Form.Group className='mb-3' controlId='urlId'>
          <Form.Label>URL（任意）</Form.Label>
          <Form.Control isInvalid={errors?.url} type='url' onChange={handleChange} name='url' value={formData?.url} placeholder='URL...' />

          <Form.Control.Feedback type='invalid'>{errors?.url}</Form.Control.Feedback>
        </Form.Group>

        {/* Tag Input */}
        <Form.Group className='mb-3' controlId='control_tag'>
          <Form.Label>Tag</Form.Label>
          <Form.Control hidden />
          <div className={formData?.tags?.length ? 'form-tags' : errors?.tags ? 'form-control is-invalid' : 'form-control'}>
            <ul className='tags'>
              {formData?.tags?.map((tag, index) => (
                <li key={index}>
                  {tag?.title}
                  <div className='remove' onClick={() => handleRemoveTag(tag)}>
                    <img src={MiniCross} alt='Cross Icon' />
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <Form.Control.Feedback type='invalid'>{errors?.tags}</Form.Control.Feedback>

          {/* Tag list initial render */}
          {tags?.length ? (
            <ul className='tags'>
              {loadMore
                ? tags?.map((tag, index) => (
                    <li key={index} onClick={() => !tag?.selected && handleSelectTag(tag)} className={tag?.selected ? 'disabled' : null}>
                      {tag?.title}
                    </li>
                  ))
                : tags?.slice(0, 5)?.map((tag, index) => (
                    <li key={index} onClick={() => !tag?.selected && handleSelectTag(tag)} className={tag?.selected ? 'disabled' : null}>
                      {tag?.title}
                    </li>
                  ))}
              <span className='more' onClick={() => setLoadMore((prevProps) => !prevProps)}>
                {loadMore ? 'Less-' : 'More+'}
              </span>
            </ul>
          ) : (
            <div className='no-found py-2'>No tag found</div>
          )}
        </Form.Group>

        {/* プッシュ通知を送信する Checkbox */}
        <div className='mb-3'>
          <input
            type='checkbox'
            id='notification_flg'
            name='notification_flg'
            value={formData?.notification_flg ? formData.notification_flg : 0}
            checked={formData?.notification_flg ? formData.notification_flg : 0}
            onChange={handleCheckboxChange}
          />
          <label htmlFor='notification_flg'>プッシュ通知を送信する</label>
        </div>
        {
          <SingleCalendar
            handleChange={handleChange}
            handleChangeDateTime={handleChangeDateTime}
            handleCheckboxChange={handleCheckboxChange}
            item={formData}
            handleAddCalendarSection={handleAddCalendarSection}
            handleRemoveCalendarSection={handleRemoveCalendarSection}
            errors={errors}
            disable={formData.ci_seminar_flg}
          />
        }

        {/* Operation User */}
        <Form.Group className='mb-3' controlId='user_name'>
          <Form.Label>
            担当者名<span className='is-required'>*</span>
          </Form.Label>
          <Form.Control
            name='user_name'
            value={formData?.user_name}
            onChange={(event) => handleChange(event)}
            type='text'
            placeholder='ご記入ください...'
            isInvalid={errors?.user_name}
          />
          <Form.Control.Feedback type='invalid'>{errors?.user_name}</Form.Control.Feedback>
        </Form.Group>
        {/* セミナーとして登録する Checkbox */}
        {/* Actions Button */}
        <div className='pb-5 pt-2'>
          <button className='button primary mb-2' onClick={(event) => handlePostPublish(event, 'preview')}>
            プレビュー
          </button>
          <button
            className='button primary mb-2'
            type='submit'
            disabled={isDisabled}
            onClick={(event) => {
              setPostStatus('scheduled');
              handlePostPublish(event, 'submit');
            }}>
            掲載予定
          </button>
          <button
            className='button primary'
            type='submit'
            onClick={(event) => {
              setPostStatus('draft');
              handleDraftPostSubmit(event);
            }}>
            下書き保存（非公開）
          </button>
        </div>
      </Form>

      {/* Schedule  modal */}
      {postStatus && typeParam && (
        <ScheduleModal
          show={showScheduleModal}
          payload={formData}
          postStatus={postStatus}
          handleClose={() => setShowScheduleModal(false)}
          mapTitle={mapTitle}
        />
      )}

      {/* Server error */}
      {serverError && <Alert variant='danger'>{serverError}</Alert>}

      {/* Post preview modal */}
      {!errorStatus && postPreviewModal && (
        <PostPreviewModal
          show={!errorStatus && postPreviewModal}
          isPreview={true}
          post={{ ...formData, original_image: originalImage, type: typeParam, items }}
          handleClose={() => setPostPreviewModal(false)}
        />
      )}
    </div>
  );
};

SinglePostForm.prototype = {
  postData: Proptypes.object,
  locationsCsv: Proptypes.array
};
